import { getFetch } from '@legacy/utils/fetcher';
import { useQuery } from '@tanstack/react-query';
import { IPlannedAbsence } from '@legacy/apis/types/plannedAbsenceAPI';
import { concatQueries } from '@legacy/utils/url';
import { IPaginationModel } from '@legacy/apis/types/paginationModelAPI';

const GET_PLANNED_ABSENCE_REPORTING_WIDGET_URL_PATH =
  '/api/v2/insights-service/planned-absence';
const GET_PLANNED_ABSENCE_REPORTING_WIDGET_MSW_STATUS_KEY =
  'getPlannedAbsenceAPI';

const GET_PLANNED_ABSENCE_REPORTING_WIDGET_KEY =
  'GET_PLANNED_ABSENCE_REPORTING_WIDGET_KEY';

const getPlannedAbsenceReportingWidget = (
  filterId: string,
  page: number = 0,
  pageSize: number = 0,
): Promise<IPlannedAbsence> =>
  getFetch({
    path: `${GET_PLANNED_ABSENCE_REPORTING_WIDGET_URL_PATH}${concatQueries([
      { param: '$pagesize', value: pageSize.toString() },
      { param: '$page', value: page.toString() },
      { param: 'filter', value: filterId },
    ])}`,
    key: GET_PLANNED_ABSENCE_REPORTING_WIDGET_MSW_STATUS_KEY,
  });

export const useGetPlannedAbsenceReportingWidget = (
  { page, pageSize }: IPaginationModel,
  filterId: string,
) => {
  const { data, ...restProps } = useQuery({
    queryKey: [
      GET_PLANNED_ABSENCE_REPORTING_WIDGET_KEY,
      filterId,
      page,
      pageSize,
    ],
    queryFn: () =>
      getPlannedAbsenceReportingWidget(filterId, page + 1, pageSize),
  });

  if (data?.properties) {
    return {
      widgetName: data?.properties.type,
      widgetData: data?.properties.data,
      paginationInfo: {
        page: data?.properties.paginationInfo.pageNumber,
        totalRecord: data?.properties.paginationInfo.totalRecord,
      },
      ...restProps,
    };
  }

  return {
    widgetName: '',
    widgetData: [],
    paginationInfo: {
      page: 0,
      totalRecord: 0,
    },
    ...restProps,
  };
};
